/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-api': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 13.75a2.413 2.413 0 00-1.25.356l-1.931-1.937a3.75 3.75 0 000-4.338L15 5.894c.376.23.809.354 1.25.356a2.5 2.5 0 10-2.5-2.5c.002.441.125.874.356 1.25L12.17 6.931a3.75 3.75 0 00-4.338 0L5.894 5a2.42 2.42 0 00.356-1.25 2.5 2.5 0 10-2.5 2.5A2.413 2.413 0 005 5.894L6.931 7.83a3.75 3.75 0 000 4.338L5 14.106a2.413 2.413 0 00-1.25-.356 2.5 2.5 0 102.5 2.5A2.412 2.412 0 005.894 15l1.937-1.931a3.75 3.75 0 004.338 0L14.106 15a2.42 2.42 0 00-.356 1.25 2.5 2.5 0 102.5-2.5zm0-11.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM2.5 3.75a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM3.75 17.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm6.25-5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm6.25 5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"/>'
  }
})
